import React from "react";
import { AnalyticsPage, AnalyticsCard, StatPill } from "./analyticsShared";

export default function TalentAnalytics() {
    return (
        <AnalyticsPage
            endpoint="/admin/analytics/talent"
            testId="admin-analytics-talent"
            overline="Analytics"
            title="Talent Supply"
            render={(d) => (
                <>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
                        <StatPill label="Total Passports" value={d.completion.total_passports} testId="ta-total" />
                        <StatPill label="With Resume" value={`${d.completion.resume_pct}%`} tone="sky" testId="ta-resume" />
                        <StatPill label="With Position" value={`${d.completion.position_pct}%`} tone="violet" testId="ta-position" />
                        <StatPill label="With LinkedIn" value={`${d.completion.linkedin_pct}%`} tone="amber" testId="ta-linkedin" />
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <AnalyticsCard title="Top desired positions" rows={d.top_positions} testId="ta-positions" />
                        <AnalyticsCard title="Top cities" rows={d.top_cities} tone="sky" testId="ta-cities" />
                        <AnalyticsCard title="Salary bands" rows={d.top_salaries} tone="violet" testId="ta-salaries" />
                        <AnalyticsCard title="Availability" rows={d.top_availability} tone="amber" testId="ta-availability" />
                        <AnalyticsCard title="Languages" rows={d.top_languages} tone="emerald" testId="ta-languages" />
                        <AnalyticsCard title="Work authorization" rows={d.top_work_auth} tone="sky" testId="ta-work-auth" />
                    </div>
                </>
            )}
        />
    );
}
